<template>
  <mdb-container class="text-left">
    <div v-if="currentGroup">
      <banner-small :group="currentGroup" title="Calendar Links"/>

          <mdb-tbl responsive striped>
            <mdb-tbl-head class="secondary-color">
              <tr>
                <th>Name</th>
                <th>Created</th>
                <th>URL</th>
                <th></th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="l in links">
                <td>
                  {{l.name}}
                </td>
                <td>
                  {{l.created}} by {{l.createdBy}}
                </td>
                <td>{{l.url}}</td>
                <td>
                  <mdb-btn icon="copy" size="sm" class="mr-2" @click="copyLink(l.url)">Copy</mdb-btn>
                  <mdb-btn icon="trash" color="danger" size="sm" @click="deleteLink(l)">Delete</mdb-btn>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
      <mdb-btn @click="addNew" icon="plus-circle">Add New Link</mdb-btn>
    </div>
    <mdb-modal v-if="showAddModal" @close="showAddModal=false" size="lg">
      <mdb-modal-header :close="true">
        <h3><i class="fa fa-link"></i>&nbsp; New Link</h3>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <div class="mb-2">A calendar link is a special URL with calendar entries (ical) that can be read by Google Calendar, Apple, etc. You may use this to embed your group
             calendar on other sites that support the ical standard.
        </div>
        <div class="mb-2"><span class="text-danger">Anyone with this link will be able to see your event titles, dates and times - even  if your group is private.</span>

        </div>
        <div class="mb-2">Give your calendar a name that indicates the purpose, who it will be shared with, etc.  You can create multiple links and delete them later, so having
            a name is important to know which is which.
        </div>
        <div class="mb-2">
            <input type="text" class="form-control" v-model="newName" placeholder="Calendar Name" required>
        </div>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn :disabled="!newName" @click="doAdd" icon="check">Create</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>

    <yes-no-modal v-if="deleteModal" question="Are you sure you wish to delete this link? Any current uses will no longer work." @yes="doDelete" @no="deleteModal=false" />

  </mdb-container>


</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {mapState} from 'vuex'
import bannerSmall from '../group/BannerSmall'
import yesNoModal from "../common/YesNoModal";
import {
  mdbBtn,
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';

export default {
    name: "group-calendar-links",
    order: 1,
    components: {
      mdbContainer, mdbModal, mdbModalHeader, mdbModalFooter, mdbModalBody,
      mdbTbl, mdbTblHead, mdbTblBody, mdbBtn,
      bannerSmall, yesNoModal
    },
    computed: mapState({
                         currentGroup: state => state.currentGroup
                       }),
    data() {
      return {
        links: [],
        newName: null,
        showAddModal: false,
        deleteCandidate: null,
        deleteModal: false
      }
    },
    mounted() {
      document.title = "Calendar Links"
      if (!this.currentGroup) {
        api.groupBasics(this.$route.params.id, "public");
      }
      this.loadLinks()
    },
    methods: {
      async copyLink(url) {
        if (!navigator.clipboard) {
          this.$notify.error({message: "Your browser does not support copying to clipboard.", timeOut: 2500})
          return
        }
        try {
          await navigator.clipboard.writeText(url)
          this.$notify.success({message: "Link copied to clipboard.", timeOut: 2500})
        } catch (e) {
          this.$notify.error({message: "Error copying to clipboard." + e, timeOut: 2500})
        }
      },
      addNew() {
        this.newName = ""
        this.showAddModal = true
      },
      deleteLink(l) {
        this.deleteCandidate = l
        this.deleteModal = true
      },
      doDelete() {
        this.deleteModal = false
        this.$store.dispatch("setExecuting", true)
        api.post("/group/deleteCalendar/" + this.$route.params.id, this.deleteCandidate).then(
          (results) => {
            this.loadLinks()
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      loadLinks() {
        this.$store.dispatch("setExecuting", true)
        api.get("/group/listCalendars/" + this.$route.params.id).then(
          (results) => {
            this.links = results.data
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      doAdd() {
        this.showAddModal = false
        this.$store.dispatch("setExecuting", true)
        api.post("/group/generateCalendarLink/" + this.$route.params.id, {name: this.newName}).then(
          (results) => {
            this.loadLinks()
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }

    }
  };

</script>

